<template>
  <div class="p-4">
    <CampaignFields :campaign="campaign" />
  </div>
</template>

<script>
import CampaignFields from "@/components/Editor/Content/CampaignFields";

export default {
  name: "Content",
  components: { CampaignFields },
  props: {
    campaign: {
      required: true,
      type: Object,
    },
  },
};
</script>
